import { useEffect, useState } from "react";
import fieldAccessDestructor from "../utils/accessUtils/fieldAccessFinder";

const useFormFieldAccess = (
  fieldAccesses,
  fieldNames,
  currentState = "unset",
  disableStateCanEditThisField
) => {
  const [disableForAccess, setDisableForAccess] = useState(false);

  useEffect(() => {
    if (fieldAccesses) {
      const hasAccesses = [];
      for (const each of fieldNames) {
        const accessKeyOfObject = each.split("_")[0];
        const hasAccess = fieldAccessDestructor(
          fieldAccesses?.[accessKeyOfObject],
          each,
          currentState,
          disableStateCanEditThisField
        )[1];
        hasAccesses.push(hasAccess);
      }
      const preventManipulate = hasAccesses.includes(false);
      if (preventManipulate) {
        setDisableForAccess(true);
      } else {
        setDisableForAccess(false);
      }
    }
  }, [fieldAccesses, currentState]);

  return disableForAccess;
};

export default useFormFieldAccess;
